'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = require('preact');

var _fela = require('fela');

var _preactFela = require('preact-fela');

var _preact2 = require('unistore/preact');

var _felaPluginNamedKeys = require('fela-plugin-named-keys');

var _felaPluginNamedKeys2 = _interopRequireDefault(_felaPluginNamedKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var namedKeysPlugin = (0, _felaPluginNamedKeys2.default)({
  desktop: '@media (min-width: 1023px)'
});

var renderer = exports.renderer = (0, _fela.createRenderer)({
  selectorPrefix: 'ecs_hl_',
  plugins: [namedKeysPlugin]
});

var Styled = function (_Component) {
  _inherits(Styled, _Component);

  function Styled() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Styled);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Styled.__proto__ || Object.getPrototypeOf(Styled)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      theme: {}
    }, _this.handleTheme = function () {
      var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.product;
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.config;

      _this.setState({
        theme: {
          key: product,
          full: config.full,
          background: config.background,
          backgroundInScroll: config.backgroundInScroll,
          color: config.color,
          gradient: (config.gradient || false).toString(),
          gradientColor: config.gradientColor,
          inverseColor: config.inverseColor
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Styled, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleTheme();

      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      style.type = 'text/css';
      style.appendChild(document.createTextNode('.ecs_hl_overflow{position:fixed;overflow:hidden;}'));
      head.appendChild(style);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.handleTheme(props.product, props.config);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var theme = this.state.theme;


      return (0, _preact.h)(
        _preactFela.Provider,
        { renderer: renderer },
        (0, _preact.h)(
          _preactFela.ThemeProvider,
          { theme: theme },
          children
        )
      );
    }
  }]);

  return Styled;
}(_preact.Component);

exports.default = (0, _preact2.connect)(function (_ref2) {
  var product = _ref2.product,
      config = _ref2.config;
  return {
    product: product,
    config: config
  };
})(Styled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/style.js
// module id = 26
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38